enum ShowOptionsEnum {
  RELEASED = 'released',
  NOT_RELEASED = 'not-released',
}

export default ShowOptionsEnum;
